"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginBoard = LoginBoard;
var react_1 = __importStar(require("react"));
var user_ctx_1 = require("./contexts/user_ctx");
var react_toastify_1 = require("react-toastify");
function LoginForm() {
    var userLogin = (0, react_1.useContext)(user_ctx_1.UserContext).userLogin;
    var _a = (0, react_1.useState)({ username: "", password: "" }), form = _a[0], setForm = _a[1];
    function handleChange(event) {
        var _a;
        setForm(__assign(__assign({}, form), (_a = {}, _a[event.target.name] = event.target.value, _a)));
    }
    function handleSubmit(event) {
        event.preventDefault();
        userLogin(form.username, form.password);
        // setForm({});
    }
    return (react_1.default.createElement("div", { className: "login-form" },
        react_1.default.createElement("h2", null, "\u7ED3\u679C\u7BA1\u7406"),
        react_1.default.createElement("form", { action: "#", onSubmit: handleSubmit },
            react_1.default.createElement("input", { name: "username", placeholder: "\u7528\u6237\u540D", required: true, onChange: handleChange, type: "text" }),
            react_1.default.createElement("input", { name: "password", placeholder: "\u5BC6\u7801", required: true, onChange: handleChange, type: "password" }),
            react_1.default.createElement("input", { type: "submit", value: "Login" })),
        react_1.default.createElement("div", { className: "company" },
            react_1.default.createElement("div", { className: "name" }, "****\u6709\u9650\u516C\u53F8"),
            react_1.default.createElement("div", { className: "phone" }, "\u8054\u7CFB\u7535\u8BDD\uFF1A13500001234"))));
}
function LoginBoard() {
    return (react_1.default.createElement("div", { className: "login-page" },
        react_1.default.createElement("div", { className: "form1", style: { marginLeft: "auto" } },
            react_1.default.createElement(LoginForm, null)),
        react_1.default.createElement("div", { className: "toast-container" },
            react_1.default.createElement(react_toastify_1.ToastContainer, null))));
}
